import VirtualList from "../../../components/common/VirtualList.component.js";

export default class InputKind {
  constructor(target, node) {
    this.target = target;
    this.node = node;
    this.mc = null;
  }

  init() {
    // Crea il clip di base
    this.mc = jQuery("#template-input-kind").clone();
    this.mc.removeAttr("id");
    this.target.append(this.mc);
    if (this.node.Field.Lookup) {
      this.initSelect();
    } else {
      this.initInput();
    }
  }

  initSelect() {
    // Rimuove il clip input
    jQuery(".js-input-kind-text", this.mc).remove();
    // Crea la virtual select
    const select = jQuery(".js-input-kind-select", this.mc);
    // Prende i valori dal provider
    const fields = [];
    for (let x = 0; x < SolrLOOKUPS[this.node.Field.Lookup].Rows.length; x++) {
      fields.push({
        id: SolrLOOKUPS[this.node.Field.Lookup].Rows[x].Value,
        label: SolrLOOKUPS[this.node.Field.Lookup].Rows[x].Label,
      });
    }

    console.log(fields);

    //this.vSelect = VirtualSelect.init({
    //  ele: select[0],
    //  options: fields,
    //  search: true,
    //  valueKey: "id",
    //  labelKey: "label",
    //  optionHeight: 30,
    //  noSearchResultsText: "Nessun risultato trovato",
    //  selectedValue: this.node.Value,
    //  silentInitialValueSet: true,
    //  hideClearButton: true,
    //});

    this.vSelect = new VirtualList(select[0], {
      options: fields,
      entryHeight: 30,
      valueKey: "id",
      labelKey: "label",
      isSelect: true,
      hasSearch: true,
      callback: this.handleSelectEvs.bind(this),
    });

    this.vSelect.init();
    this.vSelect.value = this.node.Value;

    //select[0].addEventListener("change", (e) => {
    //  this.node.Value = this.vSelect.getValue();
    //});
  }

  initInput() {
    // Rimuove il clip select
    jQuery(".js-input-kind-select", this.mc).remove();
    // Setta l'eventuale valore
    jQuery(".js-input-kind-text", this.mc).val(this.node.Value);
    // Setta gli eventi
    jQuery(".js-input-kind-text", this.mc).on("change", this.onChange.bind(this));
  }

  onChange(e) {
    this.node.Value = jQuery(e.currentTarget).val();
  }

  handleSelectEvs(e) {
    switch (e.type) {
      case "change":
        // console.log(this.vSelect.value);
        this.node.Value = this.vSelect.value;
        break;
    }
  }
}
